// File: whatsapp.service-utils.js
import { ERROR_MESSAGES } from './whatsapp.service-errors';

export const formatChatId = (chatId) => {
  if (!chatId) return null;

  // If it's already a properly formatted ID, return as is
  if (chatId.includes('@g.us') || chatId.includes('@c.us')) {
    return chatId;
  }

  // Format group ID
  if (chatId.includes('g.us')) {
    const numericId = chatId.replace(/[^0-9]/g, '');
    return numericId ? `${numericId}@g.us` : null;
  }

  // Format personal chat ID
  let formattedPhone = chatId.replace(/[^0-9]/g, '');
  if (!formattedPhone) return null;

  if (!formattedPhone.startsWith('91')) {
    formattedPhone = `91${formattedPhone}`;
  }
  return `${formattedPhone}@c.us`;
};

export const _extractInviteCode = (inviteLink) => {
  if (!inviteLink) return null;

  // If it's already just the code (not full URL), return it
  if (!inviteLink.includes('https://') && !inviteLink.includes('chat.whatsapp.com')) {
    return inviteLink;
  }

  // Try to extract from full URL
  const regex = /chat\.whatsapp\.com\/([A-Za-z0-9]+)/;
  const match = inviteLink.match(regex);

  return match ? match[1] : null;
};

export const _handleError = (error, defaultMessage) => {
  console.log('[WhatsApp Service Utils] Handling error:', {
    error: error,
    response: error.response,
    data: error.response?.data,
    status: error.response?.status
  });

  if (error.response) {
    // Server responded with error
    const status = error.response.status;
    const serverMessage = error.response.data?.error;

    console.log('[WhatsApp Service Utils] Server error:', {
      status,
      serverMessage,
      responseData: error.response.data
    });

    switch (status) {
      case 401:
        return ERROR_MESSAGES.UNAUTHORIZED;
      case 404:
        return `Session not found: ${serverMessage || 'No details available'}`;
      case 500:
        return `${ERROR_MESSAGES.SERVER_ERROR}: ${serverMessage || 'No details available'}`;
      default:
        return serverMessage || defaultMessage;
    }
  } else if (error.request) {
    // Request made but no response
    console.log('[WhatsApp Service Utils] Network error:', error.request);
    return ERROR_MESSAGES.NETWORK_ERROR;
  }

  // Something else went wrong
  console.log('[WhatsApp Service Utils] Unknown error:', error);
  return defaultMessage;
};